module.exports = __webpack_public_path__ + "img/image20.b72478c0.png";